var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-heart-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.85C2.25 4.58988 2.25 3.95982 2.49524 3.47852C2.71095 3.05516 3.05516 2.71095 3.47852 2.49524C3.95982 2.25 4.58988 2.25 5.85 2.25H12.15C13.4101 2.25 14.0402 2.25 14.5215 2.49524C14.9448 2.71095 15.2891 3.05516 15.5048 3.47852C15.75 3.95982 15.75 4.58988 15.75 5.85V9.9C15.75 11.1601 15.75 11.7902 15.5048 12.2715C15.2891 12.6948 14.9448 13.0391 14.5215 13.2548C14.0402 13.5 13.4101 13.5 12.15 13.5H10.2628C9.79477 13.5 9.56075 13.5 9.33691 13.5459C9.13832 13.5867 8.94615 13.6541 8.76562 13.7463C8.56213 13.8503 8.37939 13.9965 8.01391 14.2889L6.22482 15.7201C5.91275 15.9698 5.75672 16.0946 5.62541 16.0948C5.5112 16.0949 5.40317 16.043 5.33192 15.9537C5.25 15.8511 5.25 15.6513 5.25 15.2516V13.5C4.55252 13.5 4.20378 13.5 3.91766 13.4233C3.1412 13.2153 2.53472 12.6088 2.32667 11.8323C2.25 11.5462 2.25 11.1975 2.25 10.5V5.85Z",
    stroke: "#777777",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99769 5.77444C8.32291 4.9953 7.19766 4.78571 6.35221 5.49917C5.50676 6.21263 5.38773 7.40549 6.05167 8.2493C6.463 8.77207 7.49542 9.72686 8.22147 10.3777C8.48816 10.6168 8.62151 10.7363 8.78155 10.7845C8.91883 10.8258 9.07655 10.8258 9.21383 10.7845C9.37387 10.7363 9.50721 10.6168 9.77391 10.3777C10.5 9.72686 11.5324 8.77207 11.9437 8.2493C12.6077 7.40549 12.5032 6.20512 11.6432 5.49917C10.7832 4.79322 9.67247 4.9953 8.99769 5.77444Z",
    stroke: "#777777",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRef);
export default __webpack_public_path__ + "static/media/ref.2728fa23c0a66075a959470bfd8f8d3d.svg";
export { ForwardRef as ReactComponent };